const es = {
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.on": "Activado",
  "common.off": "Desactivado",
  "common.show": "Mostrar",
  "common.hide": "Ocultar",
  "common.hint": "Pista",
  "common.showHint": "Mostrar pista",
  "common.labelCountShowHint": "{label} {count}. Mostrar pista",

  "duration.minutes_one": "{count} minuto",
  "duration.minutes_other": "{count} minutos",
  "duration.hours_one": "{count} hora",
  "duration.hours_other": "{count} horas",

  "splash.description":
    "Aeterna Invicta busca combinar los mejores y más interesantes aspectos de Magic: The Gathering y Path of Exile en un juego de cartas coleccionables. Construye mazos, descubre sinergias y juega bien tus cartas para superar a tu oponente.",
  "splash.tagline": "¡Vuélvete eterno e invicto!",
  "splash.tutorials": "¿Jugador nuevo? ¡Haz clic aquí para ver los tutoriales!",
  "splash.enterGame": "Entrar al juego",

  "nav.collapse": "Contraer navegación",
  "nav.expand": "Expandir navegación",
  "nav.summary": "Resumen",
  "nav.game": "Juego",
  "nav.queue": "Cola",
  "nav.decks": "Mazos",
  "nav.library": "Biblioteca",
  "nav.achievements": "Diarias y logros",
  "nav.customize": "Personalizar",
  "nav.marketplace": "Mercado",
  "nav.social": "Social",
  "nav.ranking": "Clasificación",
  "nav.settings": "Ajustes",
  "nav.workshop": "Taller",
  "nav.community": "Comunidad",
  "nav.support": "Soporte",

  "hud.gameLog": "Registro de partida",
  "hud.patchNotes": "Notas del parche",
  "hud.showNavbar": "Mostrar barra de navegación",
  "hud.hideNavbar": "Ocultar barra de navegación",
  "hud.queued": "En cola",
  "hud.forfeit": "Rendirse",
  "hud.leave": "Salir",
  "hud.leaveSpectate": "Dejar de espectar",
  "hud.serverMessages": "Mensajes del servidor",
  "hud.serverMessagesNew": "Mensajes del servidor (nuevos)",

  "serverMessages.title": "Mensajes del servidor",
  "serverMessages.kindAdmin": "Mensaje del servidor",
  "serverMessages.kindMaintenance": "Mantenimiento del servidor",
  "serverMessages.inProgress":
    "El mantenimiento del servidor está en curso. El servidor puede reiniciarse en cualquier momento.",
  "serverMessages.beginsIn": "El mantenimiento del servidor comienza en",
  "serverMessages.empty": "No hay mensajes del servidor por ahora.",
  "serverMessages.view": "Ver mensajes del servidor",
  "serverMessages.template.patchApplied":
    "Hay un nuevo parche disponible. Actualiza la página o reinicia la app para cargar la versión más reciente.",
  "serverMessages.template.maintenanceComplete":
    "El mantenimiento del servidor ha terminado. ¡Gracias por tu paciencia!",
  "serverMessages.template.restartingNow":
    "El servidor se está reiniciando. Te reconectarás automáticamente en un momento.",
  "serverMessages.template.maintenanceExtended":
    "El mantenimiento del servidor está tardando más de lo previsto. Volveremos pronto.",
  "serverMessages.template.investigatingIssue":
    "Estamos al tanto de un problema y lo estamos investigando. Gracias por tu paciencia.",
  "serverMessages.template.reportBugs":
    "¡Gracias por jugar Aeterna Invicta! Reporta cualquier error desde la página de Soporte.",
  "serverMessages.template.maintenanceCountdown":
    "El mantenimiento del servidor comienza en {duration}. Termina tus partidas antes de esa hora.",
  "serverMessages.template.maintenanceStarting":
    "El mantenimiento del servidor está comenzando. El servidor puede reiniciarse en cualquier momento.",
  "serverMessages.template.maintenanceCancelled":
    "Se canceló el mantenimiento programado del servidor.",

  "completion.achievement": "Logro completado",
  "completion.daily": "Diaria completada",

  "settings.title": "Ajustes",
  "settings.backToMenu": "Volver a Ajustes",
  "settings.section.account": "Cuenta",
  "settings.section.general": "General",
  "settings.section.gameplay": "Juego",
  "settings.section.display": "Pantalla",
  "settings.section.controls": "Controles y accesibilidad",
  "settings.section.social": "Social y privacidad",
  "settings.section.danger": "Zona de peligro",
  "settings.musicVolume.label": "Volumen de música",
  "settings.soundVolume.label": "Volumen de sonido",
  "settings.volume.decrease": "Bajar {label}",
  "settings.volume.increase": "Subir {label}",
  "settings.volume.description": "Se guarda en este dispositivo.",

  "settings.language.label": "Idioma",
  "settings.language.description":
    "Elige el idioma de los menús y mensajes. Los nombres y textos de las cartas se mantienen en inglés.",

  "settings.account.label": "Cuenta",
  "settings.account.guestSuffix": " (Invitado)",
  "settings.account.guestDescription":
    "El progreso de invitado dura hasta 24 horas. Cerrar sesión elimina permanentemente esta partida de invitado.",
  "settings.account.savedDescription":
    "Sesión iniciada con una cuenta guardada en este dispositivo.",
  "settings.account.createAndKeep": "Crear cuenta y conservar progreso",
  "settings.account.migratePrompt":
    "Crea una cuenta y transfiere tu progreso actual a ella.",
  "settings.account.username": "Nombre de usuario",
  "settings.account.password": "Contraseña",
  "settings.account.migrating": "Migrando…",
  "settings.account.createAccount": "Crear cuenta",
  "settings.account.changePasswordPrompt": "Cambia tu contraseña.",
  "settings.account.currentPassword": "Contraseña actual",
  "settings.account.newPassword": "Nueva contraseña",
  "settings.account.confirmNewPassword": "Confirmar nueva contraseña",
  "settings.account.saving": "Guardando…",
  "settings.account.updatePassword": "Actualizar contraseña",
  "settings.account.changePassword": "Cambiar contraseña",
  "settings.account.logOut": "Cerrar sesión",
  "settings.account.logOutGuestConfirm":
    "¿Cerrar sesión y eliminar permanentemente esta cuenta de invitado y todo su progreso?",
  "settings.account.logOutConfirm": "¿Cerrar sesión de esta cuenta en este dispositivo?",
  "settings.account.confirmLogOut": "Confirmar cierre de sesión",

  "settings.music.label": "Música",
  "settings.music.description":
    "Reproduce música de fondo. Las pistas del menú y de las partidas son listas separadas que se reproducen en orden aleatorio con fundido, incluso al entrar o salir de una partida.",

  "settings.sound.label": "Sonido",
  "settings.sound.description":
    "Reproduce efectos de sonido al robar cartas y en otros eventos de la partida.",
  "settings.sound.skipTrack": "Saltar a la siguiente pista",

  "settings.workshop.label": "Taller",
  "settings.workshop.description":
    "Muestra u oculta el botón del Taller en la barra de navegación.",

  "settings.quickUse.label": "Mostrar uso rápido",
  "settings.quickUse.description":
    "Activa un botón opcional para agotar rápidamente por recursos y/o ataque. Básicamente te ayuda a usar equipo o habilidades con rapidez si no te importa la calidad, solo la eficiencia.",

  "settings.hints.label": "Pistas",
  "settings.hints.description":
    "Activa los botones de pistas contextuales durante las partidas. Toca un icono ? para ver texto de ayuda sobre la interfaz cercana.",

  "settings.matchGuides.label": "Guías de partida",
  "settings.matchGuides.auto": "Auto",
  "settings.matchGuides.description":
    "Resalta las cartas jugables, el equipo y las habilidades utilizables y Terminar turno, con un cuadro de ayuda plegable durante las partidas contra la CPU o jugadores. Auto muestra las guías en cuentas de invitado y en tus primeras {games} partidas.",

  "settings.cardNames.label": "Nombres de cartas",
  "settings.cardNames.description":
    "Muestra u oculta los nombres de las cartas en tu mano y de las cartas jugadas en las ranuras de equipo.",

  "settings.leftHanded.label": "Modo zurdo",
  "settings.leftHanded.description":
    "Mueve los botones de Terminar turno y Gestos al lado izquierdo y tu mano al lado derecho durante las partidas.",

  "settings.theme.label": "Tema",
  "settings.theme.dark": "Oscuro",
  "settings.theme.light": "Claro",
  "settings.theme.description": "Cambia entre diferentes temas.",

  "settings.graphics.label": "Calidad gráfica",
  "settings.graphics.auto": "Auto",
  "settings.graphics.high": "Alta",
  "settings.graphics.medium": "Media",
  "settings.graphics.low": "Baja",
  "settings.graphics.description":
    "Una calidad menor reduce el movimiento de fondo, el foil animado, los brillos y el desenfoque para mantener las partidas fluidas en dispositivos lentos. Auto elige un nivel para este dispositivo y lo baja si las partidas van a tirones. Se guarda por dispositivo.",
  "settings.graphics.autoCurrent": "Usando actualmente: {tier}.",
  "settings.graphics.autoLowered":
    "Gráficos reducidos a {tier} para mantener la partida fluida. Puedes cambiarlo en Ajustes.",

  "settings.foil.label": "Efectos foil",
  "settings.foil.minimum": "Mínimo",
  "settings.foil.maximum": "Máximo",
  "settings.foil.description":
    "Máximo anima el brillo foil en el Constructor de mazos, las partidas y el resumen. La Colección, la Biblioteca y otras cuadrículas densas se mantienen estáticas. Mínimo mantiene el foil estático en todas partes. Desactivado conserva solo tratamientos de color estáticos, como escala de grises o color alternativo.",

  "settings.toasts.label": "Notificaciones",
  "settings.toasts.cardOnly": "Solo cartas",
  "settings.toasts.textOnly": "Solo texto",
  "settings.toasts.all": "Todas",
  "settings.toasts.description":
    "Elige qué ventanas emergentes de partida y acciones aparecen. Desactivado oculta todas las notificaciones. Solo cartas muestra pequeñas vistas previas de cartas. Solo texto muestra notificaciones de mensajes. Todas muestra ambas.",

  "settings.toastSpeed.label": "Velocidad de notificaciones",
  "settings.toastSpeed.fast": "Rápida",
  "settings.toastSpeed.standard": "Estándar",
  "settings.toastSpeed.description":
    "Rápida muestra las notificaciones brevemente y luego las desvanece. Estándar mantiene el tiempo habitual. Toca o haz clic en cualquier momento para cerrarlas antes.",
  "settings.handDisplay.label": "Mostrar mano",
  "settings.handDisplay.drawer": "Cajón",
  "settings.handDisplay.dynamic": "Dinámica",
  "settings.handDisplay.description":
    "Cajón muestra tu mano completa; usa la flecha a su lado para bajar las cartas hasta sus nombres. Dinámica mantiene la mano medio oculta y levanta una carta al pasar el cursor o tocarla.",
  "match.view.hideHand": "Ocultar mano",
  "match.view.showHand": "Mostrar mano",

  "settings.fullscreen.label": "Forzar pantalla completa",
  "settings.fullscreen.description":
    "Fuerza la pantalla completa en escritorio o móvil, lo que básicamente oculta la barra de direcciones/URL.",

  "settings.controller.label": "Mando",
  "settings.controller.connected": "Conectado",
  "settings.controller.none": "No se detectó ninguno",
  "settings.controller.description":
    "La cruceta recorre los nombres de los ajustes. A abre las opciones de ese ajuste y luego A selecciona un valor. Los campos de texto abren un teclado en pantalla (A escribe, B cierra). Select o Start alterna entre la barra de navegación y la vista actual.",

  "settings.chat.label": "Chat",
  "settings.chat.turnOff": "Desactivar chat",
  "settings.chat.reviewTerms": "Revisar términos del chat",
  "settings.chat.muted": "El chat se ha desactivado para tu cuenta.",
  "settings.chat.on":
    "El chat está activado. Desactivar chat oculta todos los mensajes y te impide enviarlos. Tendrás que revisar y aceptar de nuevo los términos del chat para volver a activarlo.",
  "settings.chat.off":
    "El chat está desactivado. Revisa y acepta los términos del chat para ver y enviar mensajes.",
  "settings.chat.locked":
    "El chat está desactivado. Se desbloquea cuando tu cuenta tenga al menos 24 horas de antigüedad o después de completar {games} partidas sin rendirte.",

  "settings.blocked.label": "Jugadores bloqueados",
  "settings.blocked.unblock": "Desbloquear",
  "settings.blocked.description":
    "Los mensajes de chat y gestos de partida de los jugadores bloqueados se te ocultan, y no pueden desafiarte. Bloquea a un jugador desde su perfil en Social, Clasificación, el chat o la vista previa del jugador durante una partida.",

  "settings.adventure.label": "Aventura",
  "settings.adventure.reset": "Reiniciar Aventura",
  "settings.adventure.description":
    "Reiniciar Aventura elimina tu partida de Aventura y te permite empezar completamente de cero. Si has empezado una partida en el Modo Aventura, esto reiniciará toda tu partida de Aventura (un nuevo mapa, inventario, sin efectos, etc.).",
  "settings.adventure.none": "No hay partida de Aventura para reiniciar.",
  "settings.adventure.confirmTitle": "¿Reiniciar Aventura?",
  "settings.adventure.confirmBody":
    "Esto elimina permanentemente tu partida de Aventura, incluido tu progreso en el mapa, el inventario, el mazo de Aventura, el oro y cualquier encuentro o combate de Aventura activo. Empezarás de nuevo desde el principio.",

  "settings.deleteAccount.label": "Eliminar cuenta",
  "settings.deleteAccount.description":
    "Elimina permanentemente esta cuenta, el inicio de sesión y todo el progreso. Esto no se puede deshacer.",
  "settings.deleteAccount.typeUsername": "Escribe tu nombre de usuario ({username})",
  "settings.deleteAccount.deleting": "Eliminando…",
  "settings.deleteAccount.forever": "Eliminar cuenta para siempre",

  "deck.aspect": "Aspecto",
  "deck.equipment": "Equipo",
  "deck.ability": "Habilidad",
  "deck.defaultName": "Mazo",
  "deck.newDeck": "Nuevo mazo",
  "deck.totalPower": "Poder total",
  "deck.filters.allCards": "Todas las cartas",
  "deck.filters.allAttributes": "Todos los atributos",
  "deck.attr.strength": "Fuerza",
  "deck.attr.dexterity": "Destreza",
  "deck.attr.wisdom": "Sabiduría",
  "deck.attr.neutral": "Neutral",
  "deck.filters.allResources": "Todos los recursos",
  "deck.filters.allCosts": "Todos los costos",
  "deck.filters.allCostsResources": "Todos los costos/recursos",
  "deck.filters.fewer": "Menos filtros",
  "deck.filters.more": "Más filtros",
  "deck.filters.holoUnlocked": "Holo desbloqueado",
  "deck.filters.cardsUnlocked": "Cartas: desbloqueadas",
  "deck.filters.cardsLocked": "Cartas: bloqueadas",
  "deck.filters.cardsAll": "Cartas: todas",
  "deck.filters.clear": "Borrar filtros",
  "deck.filters.searchPlaceholder": "Buscar nombre, efecto, costo…",
  "deck.filters.allSlots": "Todas las ranuras",
  "deck.filters.allItemTypes": "Todos los tipos de equipo",
  "deck.filters.allTiers": "Todos los rangos",
  "deck.filters.allKinds": "Todas las clases",
  "deck.kind.active": "Activa",
  "deck.kind.augment": "Aumento",
  "deck.kind.essence": "Esencia",
  "deck.filters.allTypes": "Todos los tipos",
  "deck.filters.allEffects": "Todos los efectos",
  "deck.filters.sortBy": "Ordenar: {label}",
  "deck.catalog.resultCount_one": "{count} carta",
  "deck.catalog.resultCount_other": "{count} cartas",
  "deck.variant.label": "Variante",
  "deck.variant.base": "Base",
  "deck.variant.confirm": "Confirmar",
  "deck.pager.previous": "Página anterior",
  "deck.pager.next": "Página siguiente",
  "deck.pager.pageOf": "Página {page}/{total}",
  "deck.pager.perPage": "{n} por página",
  "deck.pager.all": "Todas",
  "deck.share.exportTitle": "Exportar mazo",
  "deck.share.importTitle": "Importar mazo",
  "deck.share.pastePlaceholder": "Pega el JSON del mazo",
  "deck.share.copied": "Copiado",
  "deck.share.copy": "Copiar",
  "deck.share.import": "Importar",
  "deck.analyze.none": "Ninguno",
  "deck.analyze.noOutputs": "No hay resultados de acciones medibles.",
  "deck.analyze.output": "Resultado",
  "deck.analyze.avgPerCard": "Prom. / carta",
  "deck.analyze.total": "Total",
  "deck.analyze.sectionMeta": "{count} cartas · Poder {power}",
  "deck.analyze.avgCost": "Costo prom. {cost}",
  "deck.analyze.kinds": "Clases",
  "deck.analyze.boardSlots": "Ranuras del tablero",
  "deck.analyze.equipmentSlots": "Ranuras de equipo",
  "deck.analyze.attributes": "Atributos",
  "deck.analyze.typesPresent": "Tipos presentes",
  "deck.analyze.averageOutputs": "Resultados promedio de acciones",
  "deck.analyze.title": "Analizar · {name}",
  "deck.analyze.overview": "{count} cartas · Poder {power}/{max}",
  "deck.analyze.attributesLabel": "Atributos:",
  "deck.analyze.typesLabel": "Tipos:",
  "deck.analyze.aspectMeta": "{name} · Poder {power}",
  "deck.analyze.noneSelected": "Ninguno seleccionado",
  "deck.analyze.types": "Tipos",
  "deck.analyze.pickAspect": "Elige un Aspecto para incluirlo aquí.",
  "deck.recommend.unknownCard": "Carta desconocida",
  "deck.recommend.title": "Recomendar cambios · {name}",
  "deck.recommend.aspectUnchanged": "Aspecto · Sin cambios",
  "deck.recommend.swaps": "Intercambios",
  "deck.recommend.loading": "Buscando intercambios compatibles…",
  "deck.recommend.emptyTitle": "No se encontraron intercambios compatibles.",
  "deck.recommend.emptyBody": "Ninguna de tus cartas encaja mejor en este mazo sin perder cobertura de ranuras, apoyo de recursos o margen de Poder. Tu mazo no ha cambiado.",
  "deck.recommend.staleNotice": "Tu mazo, los datos de cartas o tu colección cambiaron desde esta vista previa.",
  "deck.recommend.recommendAgainHint": "Vuelve a recomendar para obtener nuevos intercambios.",
  "deck.recommend.exhausted": "No se encontraron intercambios diferentes. Se sigue mostrando la última propuesta.",
  "deck.recommend.equipmentSlot": "Ranura de equipo {n}",
  "deck.recommend.abilitySlot": "Ranura de habilidad {n}",
  "deck.recommend.remove": "Quitar",
  "deck.recommend.add": "Añadir",
  "deck.recommend.whyAdd": "Por qué añadir",
  "deck.recommend.whyRemove": "Por qué quitar",
  "deck.recommend.disclaimer": "Las sugerencias siguen los vínculos entre cartas y no son mejoras garantizadas. Aplicar actualiza el editor; Guarda para conservar los cambios.",
  "deck.recommend.apply": "Aplicar cambios",
  "deck.recommend.again": "Recomendar de nuevo",
  "deck.recommend.tryAgain": "Intentar de nuevo",
  "deck.recommend.button": "Recomendar cambios",
  "deck.recommend.buttonTitle": "Sugerir de 2 a 4 intercambios de cartas compatibles",
  "deck.recommend.needsValidDeck": "Recomendar cambios necesita un mazo completo y válido.",
  "deck.slot.empty": "Vacía",
  "deck.slot.deckSlot": "Ranura del mazo",
  "deck.slot.clear": "Vaciar ranura",
  "deck.slot.replaceCard": "Reemplazar carta",
  "deck.picker.replaceAspect": "Reemplazar Aspecto",
  "deck.picker.chooseAspect": "Elegir Aspecto",
  "deck.picker.replaceEquipmentSlot": "Reemplazar ranura de equipo {n}",
  "deck.picker.chooseEquipmentSlot": "Elegir ranura de equipo {n}",
  "deck.picker.replaceAbilitySlot": "Reemplazar ranura de habilidad {n}",
  "deck.picker.chooseAbilitySlot": "Elegir ranura de habilidad {n}",
  "deck.picker.hideFilters": "Ocultar filtros/búsqueda",
  "deck.picker.showFilters": "Mostrar filtros/búsqueda",
  "deck.picker.suggest": "Sugerir cartas",
  "deck.sort.name": "Ordenar: Nombre",
  "deck.sort.type": "Ordenar: Tipo",
  "deck.sort.attribute": "Ordenar: Atributo",
  "deck.sort.resources": "Ordenar: Recursos",
  "deck.sort.cost": "Ordenar: Costo",
  "deck.sort.power": "Ordenar: Poder",
  "deck.sort.slot": "Ordenar: Ranura",
  "deck.sort.kind": "Ordenar: Clase",
  "deck.sort.holo": "Ordenar: Cantidad de holo",
  "deck.builder.title": "Constructor de mazos",
  "deck.builder.setDefault": "Predeterminar",
  "deck.builder.clone": "Clonar",
  "deck.builder.save": "Guardar",
  "deck.builder.delete": "Eliminar",
  "deck.builder.export": "Exportar",
  "deck.builder.analyze": "Analizar",
  "deck.builder.default": "Predeterminado",
  "deck.builder.unsaved": "Sin guardar",
  "deck.builder.deleteTitle": "¿Eliminar mazo?",
  "deck.builder.deleteBody": "Eliminar permanentemente {name}. Esto no se puede deshacer.",
  "match.board.healthCost": "{amount} de salud",
  "match.board.alreadyPlayedAbility": "Ya jugaste una habilidad este turno.",
  "match.board.tagInherent": "inherente",
  "match.board.tagCombo": "combo",
  "match.board.tagLevel": "Nv{level}",
  "match.board.tagActiveMinion": "{name} activo {hp}",
  "match.board.tagActiveAura": "{name} activa",
  "match.board.slotTitleCanLevelUp": "Puede subir de nivel · selecciona para ver acciones",
  "match.board.slotTitleEmpowerArmor": "Potenciar esta carta de Armadura física",
  "match.board.slotTitleLinkedAugment": "Aumento vinculado coincidente",
  "match.board.slotTitleSlotHere": "Coloca la habilidad aquí",
  "match.board.mismatch": "No coincide",
  "match.board.expendedSuffix": " · agotado",
  "match.board.auraActiveTitle": "{name} · Aura activa",
  "match.board.linkedActiveUsed": "{name} · activa vinculada usada",
  "match.board.slotTitleInert": "{name} · inactiva fuera de la ranura principal",
  "match.board.costTitle": "Costo {cost}",
  "match.board.emptyAbilitySlot": "Ranura de habilidad vacía",
  "match.board.fletchCounter_one": "{count} carga de emplumado",
  "match.board.fletchCounter_other": "{count} cargas de emplumado",
  "match.board.activeBadge": "Activa",
  "match.board.you": "TÚ",
  "match.board.opp": "RIV",
  "match.board.timerMulligan": "Temporizador de mulligan",
  "match.board.timerTurn": "Temporizador de turno",
  "match.board.timerMatch": "Temporizador de partida",
  "match.board.mulligan": "Mulligan",
  "match.board.yourTurn": "Tu turno",
  "match.board.playerTurn": "Turno de {name}",
  "match.board.firstPlayerWillBe": "El 1.er jugador será {name} · ",
  "match.board.round": "Ronda {round}",
  "match.board.peekEquipment": "Equipo",
  "match.board.noEquipment": "Sin equipo",
  "match.board.peekAbilities": "Habilidades",
  "match.board.noAbilities": "Sin habilidades",
  "match.board.noOccupiedSlots": "No hay ranuras ocupadas",
  "match.board.healthOrbLabel": "Salud {hp} de {maxHp}",
  "match.board.quests": "Misiones",
  "match.board.tapAgainToExpend": "Toca de nuevo para agotar: {action}",
  "match.board.targetAspect": "Aspecto objetivo",
  "match.board.aspect": "Aspecto",
  "match.board.aspectSlotLabel": "Ranura de Aspecto",
  "match.board.aspectSlot": "Ranura de Aspecto",
  "match.board.slotWeapon": "Arma",
  "match.board.slotArmor": "Armadura",
  "match.board.slotTrinket": "Baratija",
  "match.board.minion": "Esbirro",
  "match.board.aura": "Aura",
  "match.board.expend": "Agotar",
  "match.board.minionHealthLabel": "Salud de {name}: {hp} de {maxHp}",
  "match.board.auraActiveLabel": "{name} activa",
  "match.board.hexed": "Con maleficio",
  "match.board.expendCost": "Agotar +{cost}",
  "match.board.equipHere": "Equipar aquí",
  "match.board.slotTitle": "Ranura de {slot}",
  "match.board.slotAriaLabel": "Ranura de {slot}",
  "match.board.quickRefresh": "REFRESCAR",
  "match.board.quickEncore": "ENCORE",
  "match.board.quickSlotDamage": "DAÑO RAN.",
  "match.board.quickRepair": "REPARAR",
  "match.board.gainResources": "Obtener recursos",
  "match.board.dealDamage": "Infligir daño",
  "match.board.heal": "Curar",
  "match.board.physicalArmor": "Armadura física",
  "match.board.magicArmor": "Armadura mágica",
  "match.board.resolveTargetingFirst": "Primero resuelve la selección de objetivo.",
  "match.board.equipmentBrokenCannotExpend": "Ese equipo está roto y no se puede agotar.",
  "match.board.equipmentCannotExpend": "Ese equipo no se puede agotar.",
  "match.board.refreshRequiresExpended": "Refrescar requiere equipo agotado.",
  "match.board.cannotUseAction": "No puedes usar esa acción.",
  "match.board.equipmentAction": "Acción de equipo",
  "match.board.notEnoughPhysicalArmor": "No hay suficiente armadura física.",
  "match.board.examine": "Examinar",
  "match.board.deactivateAura": "Desactivar aura",
  "match.board.effectFallback": "Efecto",
  "match.board.encore": "Encore",
  "match.board.slottedDamage": "+{amount} daño de ranura",
  "match.board.repair": "Reparar",
  "match.board.equipmentNotExpended": "El equipo no está agotado.",
  "match.board.refresh": "Refrescar",
  "match.board.charge": "Cargar",
  "match.board.discard": "Descartar",
  "match.board.levelUpAbility": "Subir de nivel habilidad",
  "match.board.empowerEquipment": "Potenciar equipo",
  "match.board.empowerAbility": "Potenciar habilidad",
  "match.board.unsummon": "Desinvocar",
  "match.board.deactivate": "Desactivar",
  "match.board.alreadyActivated": "Ya se activó este turno.",
  "match.board.minionAlreadyActive": "El esbirro ya está activo.",
  "match.board.auraAlreadyActive": "El aura ya está activa.",
  "match.board.hostEquipmentOccupied": "El equipo anfitrión está ocupado.",
  "match.board.unsummonMinionFirst": "Primero desinvoca al esbirro.",
  "match.board.deactivateAuraFirst": "Primero desactiva el aura.",
  "match.board.moveAbility": "Mover habilidad",
  "match.board.remainingActs": "Acciones restantes:",
  "match.board.remainingEquip": "Equipar",
  "match.board.remainingAbility": "Habilidad",
  "match.board.remainingExpendGear": "Agotar equipo",
  "match.board.remainingActivateAbilities": "Activar hab.",
  "match.board.hintEquip": "Una vez por turno, equipa una carta de Equipo de tu mano en una ranura corporal vacía.",
  "match.board.hintAbility": "Una vez por turno, coloca una Habilidad de tu mano en tu tablero o mueve una Habilidad colocada a una ranura vacía. Descartar una Habilidad colocada es gratis y no usa esta acción.",
  "match.board.hintExpendGear": "Cada objeto equipado puede agotarse una vez por turno para obtener recursos o su efecto de agotar. Varias opciones de agotar en el mismo objeto cuentan como una sola.",
  "match.board.hintActivateAbilities": "Cada Habilidad activa colocada sin usar que aún puede activarse este turno. Igualmente debes pagar su costo al activarla.",
  "match.board.notEnoughResources": "No hay suficientes recursos.",
  "match.board.effectNumber": "Efecto {number}",
  "match.board.actionNumber": "Acción {number}",
  "match.board.noEmptyAbilitySlots": "No hay ranuras de habilidad vacías.",
  "match.board.selectEmptyAbilitySlot": "Selecciona una ranura de habilidad vacía.",
  "match.panel.aspect": "Aspecto",
  "match.panel.aspectEmpty": "Aspecto · Vacío",
  "match.panel.equipment": "Equipo",
  "match.panel.slotEmpty": "{slot} · Vacía",
  "match.panel.minion": "Esbirro",
  "match.panel.aura": "Aura",
  "match.panel.onEquipment": " · en {name}",
  "match.panel.charges": "Cargas",
  "match.panel.durability": "Durabilidad",
  "match.panel.broken": " (Roto)",
  "match.panel.unsummon": "Desinvocar",
  "match.panel.deactivate": "Desactivar",
  "match.panel.gain": "Obtener",
  "match.panel.toast.resolveTargetingFirst": "Primero resuelve la selección de objetivo.",
  "match.panel.toast.notEnoughPhysicalArmor": "No hay suficiente armadura física.",
  "match.panel.toast.refreshRequiresExpended": "Refrescar requiere equipo agotado.",
  "match.panel.toast.equipmentCannotExpend": "Ese equipo no se puede agotar.",
  "match.panel.toast.resolvePendingChoiceFirst": "Primero resuelve la elección pendiente.",
  "match.panel.refresh": "Refrescar",
  "match.panel.charge": "Cargar",
  "match.panel.encore": "Encore",
  "match.panel.slottedDamageButton": "+{amount} daño de ranura",
  "match.panel.repair": "Reparar",
  "match.panel.discard": "Descartar",
  "match.panel.examine": "Examinar",
  "match.panel.traits": "Rasgos",
  "match.panel.aspectTraitTreeAria": "Árbol de rasgos de {name}",
  "match.panel.levelTrait": "Rasgo de nivel {level}",
  "match.panel.levelTraitLabel": "Nivel {level}: {label}",
  "match.panel.aspectBaseEffect": "Efecto base del Aspecto",
  "match.panel.allocated": "Asignado",
  "match.panel.traitOption": "Opción de rasgo",
  "match.panel.clickAnywhereToClose": "Haz clic en cualquier lugar para cerrar",
  "match.panel.tapNodeHint": "Toca un nodo para inspeccionar los Rasgos y el efecto base del Aspecto.",
  "match.panel.viewArtAria": "Ver ilustración de {name}",
  "match.panel.variant": "Variante",
  "match.panel.variantBase": "Base",
  "match.panel.expansionSetAria": "Expansión {set}",
  "match.panel.set": "Expansión",
  "match.panel.power": "Poder",
  "match.panel.attributes": "Atributos",
  "match.panel.attribute": "Atributo",
  "match.panel.kind": "Clase",
  "match.panel.linksTo": "Se vincula con",
  "match.panel.or": "o",
  "match.panel.matchingActiveAbilities": "Habilidades activas coincidentes",
  "match.panel.slot": "Ranura",
  "match.panel.boardSlotSub": "Ranura de tablero: {slot}",
  "match.panel.matchEffect": "Efecto de partida",
  "match.panel.passive": "Pasivo",
  "match.panel.kindEffect": "Efecto de {kind}",
  "match.panel.effect": "Efecto",
  "match.panel.effectLower": "efecto",
  "match.panel.triggers": "Desencadenantes",
  "match.panel.expend": "Agotar",
  "match.panel.equipmentActions": "Acciones de equipo",
  "match.panel.cardText": "Texto de la carta",
  "match.panel.invoke": "Invocar",
  "match.panel.levelProgression": "Progresión de niveles",
  "match.panel.traitTree": "Árbol de rasgos",
  "match.panel.tapArtToEnlarge": "Toca la ilustración para ampliarla",
  "match.panel.ability": "Habilidad",
  "match.panel.health": "Salud",
  "match.panel.expendedThisTurn": "Agotado este turno",
  "match.panel.minions": "Esbirros",
  "match.panel.hostEquipment": "Equipo anfitrión · {name}",
  "match.panel.appliedEffects": "Efectos aplicados",
  "match.panel.applyAbility": "Aplicar {name}",
  "match.panel.used": "Usada",
  "match.panel.activeMinionStatus": "{name} activo {hp}",
  "match.panel.activeStatus": "{name} activo",
  "match.panel.mismatch": "No coincide",
  "match.panel.level": "Nivel",
  "match.panel.baseLevel": "Base {level}",
  "match.panel.status": "Estado",
  "match.panel.levelUpAbility": "Subir de nivel habilidad",
  "match.panel.exportGameLogTitle": "Descarga una instantánea JSON del registro de partida hasta ahora",
  "match.panel.exporting": "Exportando…",
  "match.panel.export": "Exportar",
  "match.panel.noActionsYet": "Aún no hay acciones.",
  "match.panel.quests": "Misiones",
  "match.panel.eachTurn": "Cada turno",
  "match.panel.eachTurnHint": "Complétalas en cualquier orden. Se reinician al comienzo de tu siguiente turno.",
  "match.panel.duringGame": "Durante la partida",
  "match.panel.duringGameHint": "Complétalas una vez por partida, en cualquier orden.",
  "match.panel.chooseSlottedResource": "Elige un recurso que coincida con una habilidad colocada.",
  "match.panel.convertNeutral": "Convierte 1 Neutral en un atributo de tu elección.",
  "match.panel.chooseFocusResourcePrompt": "Elige Fuerza, Destreza o Sabiduría. Obtén 1 de ese recurso.",
  "match.panel.chooseIdentity": "Elegir identidad",
  "match.panel.chooseIdentityPrompt": "Elige una identidad. Este equipo adopta el atributo primario elegido mientras esté equipado.",
  "match.panel.levelUp": "Subir de nivel",
  "match.panel.levelN": "Nivel {level}",
  "match.panel.tierN": "Rango {tier}",
  "match.panel.tier": "Rango",
  "match.panel.selected": "Seleccionado",
  "match.panel.notChosen": "No elegido",
  "match.panel.futureChoice": "Elección futura",
  "match.panel.traitChoiceHint": "Selecciona un nodo brillante y luego Confirmar para fijar tu Rasgo.",
  "match.panel.traitTreeAria": "Árbol de rasgos",
  "match.panel.viewBoard": "Ver tablero",
  "match.panel.confirmTrait": "Confirmar rasgo",
  "match.panel.clickOutsideToClose": "Haz clic fuera para cerrar",
  "match.panel.showLevelUpPrompt": "Mostrar aviso de subida de nivel",
  "match.panel.hideLevelUpPrompt": "Ocultar aviso de subida de nivel",
  "match.panel.levelUpAbilityPrompt": "Selecciona una Habilidad de {attribute} resaltada y elige Subir de nivel habilidad u Omitir para obtener +3 XP.",
  "match.panel.empowerPhysicalArmorCard": "Potenciar carta de Armadura física",
  "match.panel.empowerEquipment": "Potenciar equipo",
  "match.panel.empowerPhysicalArmorHint": "Elige una habilidad colocada resaltada en amarillo que otorgue Armadura física para subirla de nivel, o un equipo cuyo efecto de agotar otorgue Armadura física para aumentar esa armadura en 1 (la armadura pasiva no cambia), u Omitir para obtener +3 XP.",
  "match.panel.empowerEquipmentHint": "Elige un equipo de Sabiduría resaltado en amarillo que otorgue Armadura mágica para aumentar en 1 tanto su Armadura mágica pasiva como la de agotar, u Omitir para obtener +3 XP.",
  "match.panel.chargeResourceSpend": "{label}: {current}. Gasta {per} por cada uno para obtener Fuerza, Destreza o Sabiduría.",
  "match.panel.allocateUpTo": "Asigna hasta {max}. Quedan {remaining}.",
  "match.panel.maxValue": "máx. {max}",
  "match.panel.confirm": "Confirmar",
  "match.panel.payFor": "Pagar {name}",
  "match.panel.spendAnyFlex": "Gasta {amount} cualesquiera entre fuerza, destreza, sabiduría o neutral",
  "match.panel.remaining": "Quedan {amount}",
  "match.panel.decreaseAria": "Disminuir {attribute}",
  "match.panel.increaseAria": "Aumentar {attribute}",
  "match.panel.hiddenCard": "Carta oculta",
  "match.panel.discardAndDraw": "Descartar y robar",
  "match.panel.equip": "Equipar",
  "match.panel.slotAction": "Colocar",
  "match.panel.plusOnePhysArmor": "+1 Arm. física",
  "match.view.enemies": "Enemigos",
  "match.view.statusBleed": "Sangrado {amount}",
  "match.view.statusPoison": "Veneno {amount}",
  "match.view.statusBurn": "Quemadura {amount}",
  "match.view.statusChill": "Escarcha {amount}",
  "match.view.statusShock": "Descarga {amount}",
  "match.view.statusWither": "Marchitez {amount}",
  "match.view.statusHex": "Maleficio {amount}",
  "match.view.statusRegen": "Regen. {amount}",
  "match.view.regeneration": "Regeneración",
  "match.view.wither": "Marchitez",
  "match.view.enemyDefeated": "Derrotado",
  "match.view.enemySelectedTarget": "Objetivo seleccionado",
  "match.view.enemySelect": "Seleccionar enemigo",
  "match.view.enemyExamine": "Examinar enemigo",
  "match.view.emptyEnemySlotAria": "Ranura de enemigo vacía {slot}",
  "match.view.emptySlot": "Vacía",
  "match.view.matchOver": "Partida terminada",
  "match.view.waitingForSummary": "Esperando el resumen…",
  "match.view.resultDraw": "Empate",
  "match.view.endedTimeout": "Tiempo agotado",
  "match.view.endedCombat": "Combate",
  "match.view.tutorialComplete": "Tutorial completado",
  "match.view.tryAgain": "Intentar de nuevo",
  "match.view.victory": "Victoria",
  "match.view.defeat": "Derrota",
  "match.view.deckPower": "Poder {total}/{max}",
  "match.view.deckAspectPower": "Aspecto · Poder {power}",
  "match.view.deckEquipmentPower": "Equipo ({cards}) · Poder {power}",
  "match.view.deckAbilitiesPower": "Habilidades ({cards}) · Poder {power}",
  "match.view.noneRemaining": "No queda ninguna",
  "match.view.you": "Tú",
  "match.view.winner": "Ganador",
  "match.view.board": "Tablero",
  "match.view.handCount": "Mano ({n})",
  "match.view.deckCount": "Mazo ({n})",
  "match.view.discardCount": "Descarte ({n})",
  "match.view.continue": "Continuar",
  "match.view.adNotCompleted": "El anuncio no se completó.",
  "match.view.adStartFailed": "No se pudo iniciar el anuncio.",
  "match.view.adExtraUnlock": "Mira un anuncio para obtener un desbloqueo extra",
  "match.view.unlockedCards_one": "Desbloqueaste {count} carta",
  "match.view.unlockedCards_other": "Desbloqueaste {count} cartas",
  "match.view.unlockedFoils_one": "Desbloqueaste {count} recompensa foil",
  "match.view.unlockedFoils_other": "Desbloqueaste {count} recompensas foil",
  "match.view.bonusAvailable": "Bonificación {bonus} disponible",
  "match.view.earned": "Obtenido",
  "match.view.adPromptTitle": "¿Ver anuncio?",
  "match.view.adPromptBody": "¿Te gustaría ver un anuncio breve para desbloquear variantes foil adicionales de cartas desbloqueadas? Usaremos el dinero de la publicidad para cubrir los costos del servidor y el desarrollo continuo. ¡Gracias de antemano por tu apoyo!",
  "match.view.loading": "Cargando...",
  "match.view.adWatch": "Ver anuncio",
  "match.view.notNow": "Ahora no",
  "match.view.none": "Ninguno",
  "match.view.endedBy": "Terminó por",
  "match.view.rounds": "Rondas",
  "match.view.opponent": "Oponente",
  "match.view.damageDealt": "Daño infligido",
  "match.view.damageTaken": "Daño recibido",
  "match.view.healed": "Curado",
  "match.view.throwAway": "Desechar",
  "match.view.reportChooseCategory": "Elige una categoría de reporte.",
  "match.view.chatTurnedOff": "El chat está desactivado. Revisa los términos del chat para volver a activarlo.",
  "match.view.queueTitle": "En cola para partida contra jugador...",
  "match.view.playersInQueue": "Jugadores en cola: {players}",
  "match.view.cancelQueue": "Cancelar cola",
  "match.view.discardPileAria": "Pila de descarte de {name}",
  "match.view.discardViewerHint": "Las más recientes primero. Toca una carta para examinarla.",
  "match.view.discardEmpty": "No hay cartas en el descarte.",
  "match.view.account.passwordTooShort": "La contraseña debe tener al menos 4 caracteres.",
  "match.view.account.passwordMismatch": "Las nuevas contraseñas no coinciden.",
  "match.view.account.passwordUpdated": "Contraseña actualizada.",
  "match.view.account.changePasswordFailed": "No se pudo cambiar la contraseña.",
  "match.view.account.requestFailed": "La solicitud falló.",
  "match.view.account.typeUsernameToConfirm": "Escribe tu nombre de usuario exactamente para confirmar.",
  "match.view.account.enterCurrentPassword": "Introduce tu contraseña actual.",
  "match.view.account.deleteFailed": "No se pudo eliminar la cuenta.",
  "match.view.account.enterUsername": "Introduce un nombre de usuario.",
  "match.view.account.usernameNoSpaces": "El nombre de usuario no debe contener espacios.",
  "match.view.account.createFailed": "No se pudo crear la cuenta.",
  "match.view.winnerBanner": "Ganador: {name}",
  "match.view.quickUseEquipment": "Uso rápido de equipo para recursos",
  "match.view.quickUseAbilities": "Uso rápido de habilidades de daño",
  "match.view.hand": "Mano",
  "match.view.noCardsInHand": "No hay cartas en la mano",
  "match.view.handHint": "Esta es tu mano. Tus mazos de equipo y de habilidades se barajan juntos. Puedes tener hasta cuatro cartas en la mano, que se reponen hasta el máximo al comienzo de cada uno de tus turnos. Puedes equipar una carta de equipo por turno y realizar una jugada de habilidad por turno: colocarla en una ranura vacía, mover una habilidad colocada o devolverla a la mano.",
  "match.guide.label": "Guía",
  "match.guide.show": "Mostrar guía",
  "match.guide.hide": "Minimizar guía",
  "match.guide.turnOff": "Desactivar guías",
  "match.guide.turnedOff": "Guías de partida desactivadas. Vuelve a activarlas en Ajustes.",
  "match.guide.title.openingHand": "Mano inicial",
  "match.guide.title.yourTurn": "Tu turno",
  "match.guide.title.opponentTurn": "Turno del oponente",
  "match.guide.title.makeChoice": "Haz una elección",
  "match.guide.mulligan": "Quédate con esta mano o pulsa Mulligan una vez para volver a robar. Pulsa Listo cuando estés preparado.",
  "match.guide.mulliganWaiting": "Esperando a que tu oponente esté listo.",
  "match.guide.opponentTurn": "Observa lo que juega tu oponente. Toca cualquier carta para examinarla. Tu mano se repone al comienzo de tu turno.",
  "match.guide.pendingChoice": "Termina la elección resaltada (elige un objetivo u opción) o cancélala antes de hacer cualquier otra cosa.",
  "match.guide.playEquipment": "Equipar: toca una carta de Equipo brillante en tu mano y pulsa Equipar (1 por turno).",
  "match.guide.slotAbility": "Habilidad: toca una carta de Habilidad brillante en tu mano, pulsa Colocar y luego elige una ranura de habilidad vacía (1 por turno).",
  "match.guide.expendEquipment_one": "Agotar: toca el equipo brillante de tu tablero para obtener recursos o su efecto.",
  "match.guide.expendEquipment_other": "Agotar: toca el equipo brillante de tu tablero para obtener recursos o efectos ({count} listos).",
  "match.guide.activateAbilities_one": "Activar: toca la habilidad brillante de tu tablero para usarla.",
  "match.guide.activateAbilities_other": "Activar: toca las habilidades brillantes de tu tablero para usarlas ({count} listas).",
  "match.guide.needResources": "Algunas habilidades necesitan más recursos. Agota equipo primero para pagarlas.",
  "match.guide.nothingLeft": "No queda nada por jugar ni usar. Pulsa Terminar turno.",
  "match.guide.idle": "¿Atascado? Puedes pulsar Terminar turno en cualquier momento.",
  "match.guide.invoke": "Opcional: Invoca una carta de tu mano, descartándola para obtener su efecto de Invocar.",
  "match.view.viewingYourBoard": "Viendo tu tablero",
  "match.view.viewingEnemies": "Viendo enemigos",
  "match.view.viewingPlayerBoard": "Viendo el tablero de {name}",
  "match.view.cycleBoardView": "Cambiar vista del tablero",
  "match.view.viewLabel": "Vista",
  "match.view.viewEnemy": "Enemigo",
  "match.view.viewAlly": "Aliado",
  "match.view.viewOpp": "Riv.",
  "match.view.viewSelf": "Propio",
  "match.view.showMatchEmotes": "Mostrar gestos de partida",
  "match.view.hideAllMatchEmotes": "Ocultar todos los gestos de partida",
  "match.view.showEmotes": "Mostrar gestos",
  "match.view.hideEmotes": "Ocultar gestos",
  "match.view.emotes": "Gestos",
  "match.view.sendEmote": "Enviar gesto {emoji}",
  "match.view.mulliganed": "Hizo mulligan",
  "match.view.mulligan": "Mulligan",
  "match.view.closeEmotes": "Cerrar gestos",
  "match.view.openEmotes": "Abrir gestos",
  "match.view.emote": "Gesto",
  "match.view.ready": "Listo",
  "match.view.cancelEffectUse": "Cancelar uso del efecto",
  "match.view.cancelAbilityUse": "Cancelar uso de la habilidad",
  "match.view.cancelEffectUseConfirm": "¿Cancelar uso del efecto?",
  "match.view.cancelAbilityUseConfirm": "¿Cancelar uso de la habilidad?",
  "match.view.skipAbilityLevelUpTitle": "Omitir subida de nivel de habilidad por +3 XP",
  "match.view.skip": "OMITIR",
  "match.view.chooseAbilityOrSkipTitle": "Elige una Habilidad resaltada u Omitir antes de terminar tu turno",
  "match.view.endTurnLine1": "FIN DEL",
  "match.view.endTurnLine2": "TURNO",
  "match.view.skipEquipmentTraitTitle": "Omitir rasgo de equipo por +3 XP",
  "match.view.chooseAbilityOrEquipmentOrSkipTitle": "Elige una habilidad o equipo resaltado u Omitir antes de terminar tu turno",
  "match.view.chooseEquipmentOrSkipTitle": "Elige un equipo resaltado u Omitir antes de terminar tu turno",
  "match.view.chooseTraitLine1": "Elegir",
  "match.view.chooseTraitLine2": "Rasgo",
  "match.view.viewBoardLine1": "Ver",
  "match.view.viewBoardLine2": "Tablero",
  "match.view.chooseTraitTitle": "Elige un Rasgo antes de terminar tu turno",
  "match.view.chooseIdentityLine1": "Elegir",
  "match.view.chooseIdentityLine2": "Identidad",
  "match.view.chooseIdentityTitle": "Elige una identidad antes de terminar tu turno",
  "match.view.noResourcesSpent": "No se gastarán recursos.",
  "match.view.noRefund": "No se te reembolsará el costo de {name}.",
  "match.view.thisEffect": "este efecto",
  "match.view.keepTargeting": "Seguir eligiendo objetivo",
  "game.toast.error": "Error",
  "game.toast.yourTurn": "Tu turno",
  "game.toast.yourTurnOpeningBlocked": "Tu turno · Juegas primero, así que no infliges daño en tu primer turno",
  "game.gameLog.exportFailed": "No se pudo exportar el registro de partida.",
  "game.gameLog.copied": "Registro de partida copiado al portapapeles ({entries} entradas)",
  "game.gameLog.exported": "Registro de partida exportado ({entries} entradas)",
  "game.payment.kind.ability": "Habilidad",
  "game.payment.kind.sharpen": "Afilar",
  "game.payment.kind.hone": "Pulir",
  "game.payment.kind.fletch": "Emplumar",
  "game.payment.kind.encore": "Encore",
  "game.payment.kind.research": "Investigar",
  "game.payment.kind.repair": "Reparar",
  "game.deck.recommendStale": "Tu mazo cambió. Vuelve a recomendar para obtener nuevos intercambios.",
  "game.deck.recommendInvalid": "Estos intercambios ya no son válidos.",
  "game.deck.recommendApplied_one": "Se aplicó {count} intercambio. Guarda para conservarlo.",
  "game.deck.recommendApplied_other": "Se aplicaron {count} intercambios. Guarda para conservarlos.",
  "game.deck.limitReached": "Se alcanzó el límite de mazos.",
  "game.deck.imported": "Importado: {name}",
  "game.workshop.seatOpponent": "Oponente",
  "game.workshop.seatYou": "Tú",
  "game.workshop.maxCopies": "Máximo {max} copias de {name}.",
  "game.workshop.addedToAbilityHand": "Añadida a la mano de habilidades. Selecciona una ranura.",
  "common.attribute.strength": "Fuerza",
  "common.attribute.dexterity": "Destreza",
  "common.attribute.wisdom": "Sabiduría",
  "common.attribute.neutral": "Neutral",
  "deck.sort.name": "Nombre",
  "deck.sort.category": "Categoría",
  "deck.sort.type": "Tipo",
  "deck.sort.attribute": "Atributo",
  "deck.sort.resources": "Recursos",
  "deck.sort.cost": "Costo",
  "deck.sort.power": "Poder",
  "deck.sort.slot": "Ranura",
  "deck.sort.tier": "Rango",
  "deck.sort.kind": "Clase",
  "deck.sort.holo": "Cantidad de holo",
  "match.quest.equip": "Equipa una carta de Equipo",
  "match.quest.slotAbility": "Coloca una carta de Habilidad",
  "match.quest.resourceExpend": "Obtén al menos 1 recurso",
  "match.quest.combatDamage": "Inflige daño no bloqueado",
  "match.quest.healBuff": "Obtén un efecto de apoyo, como curación o armadura",
  "match.quest.fullEquipment": "Ten equipo en las 3 ranuras al mismo tiempo",
  "match.quest.fullAbilities": "Ten una habilidad colocada en las 3 ranuras activas o principales al mismo tiempo",
  "match.quest.equipAllSlots": "Equipa cada ranura de equipo al menos una vez",
  "match.quest.activateLevel2Ability": "Activa una vez una Habilidad colocada de nivel 2",
  "match.quest.activateAugmentedAbility": "Activa una vez una Habilidad con un Aumento coincidente",
  "match.questStep.weapon": "Arma",
  "match.questStep.trinket": "Baratija",
  "match.questStep.body": "Cuerpo",
  "match.questStep.hands": "Manos",
  "match.questStep.feet": "Pies",
  "match.questStep.head": "Cabeza",
  "game.serverToast.mulliganFirstPlayer": "FASE DE MULLIGAN - El primer jugador será {name}",
  "game.serverToast.ranOutOfTime": "¡Se te acabó el tiempo!",
  "match.lobby.backToMatch": "Volver a la partida",
  "match.lobby.classic": "Clásico",
  "match.lobby.queueVsCpu": "Cola contra CPU",
  "match.lobby.vsCpu": "CONTRA CPU",
  "match.lobby.playersInQueue_one": "Jugadores en cola: {count}",
  "match.lobby.playersInQueue_other": "Jugadores en cola: {count}",
  "match.lobby.queueVsHuman": "Cola contra jugador",
  "match.lobby.vsHuman": "CONTRA JUGADOR",
  "match.lobby.cancelQueue": "Cancelar cola",
  "match.lobby.enterQueueVsHuman": "Entrar en cola contra jugador",
  "match.lobby.playAgainstCpu": "Jugar contra la CPU",
  "match.lobby.setValidDeck": "Elige un mazo válido antes de entrar en cola.",
  "match.lobby.currentDeck": "Mazo actual:",
  "match.lobby.randomDeck": "🎲 Mazo aleatorio",
  "match.lobby.randomDeckHint": "Se elegirá un mazo válido aleatorio al entrar en cola.",
  "match.lobby.deckPreview": "Vista previa del mazo",
  "match.lobby.noAspect": "Sin Aspecto",
  "match.lobby.modes": "Modos",
  "match.lobby.collectDraftRewards": "Reclamar recompensas del Draft",
  "match.lobby.continueDraftMode": "Continuar Modo Draft",
  "match.lobby.playDraftModeFree": "Jugar Modo Draft (GRATIS)",
  "match.lobby.playDraftModeCost": "Jugar Modo Draft ({cost} de moneda)",
  "match.lobby.collectDraft": "Reclamar Draft",
  "match.lobby.continueDraft": "Continuar Draft",
  "match.lobby.draftFree": "Draft (GRATIS)",
  "match.lobby.draft": "Draft",
  "match.lobby.continueAdventureMode": "Continuar Modo Aventura",
  "match.lobby.playAdventureMode": "Jugar Modo Aventura",
  "match.lobby.continueAdventure": "Continuar Aventura",
  "match.lobby.adventure": "Aventura",
  "match.lobby.tutorialScenarios": "Escenarios de tutorial",
  "match.lobby.tutorials": "Tutoriales",
  "match.lobby.draftStatus": "Draft: {lives} vidas · {played}/{max} partidas · V {wins} / D {losses} / E {draws}",
  "match.lobby.draftRound": "Draft: Ronda {round}/{total}",
  "match.lobby.collectDraftFirst": "Reclama las recompensas del Draft antes de empezar uno nuevo.",
  "match.popup.challengeTitle": "Desafío",
  "match.popup.challengeBody": "{name} te desafió a una partida.",
  "match.popup.partyInviteTitle": "Invitación de grupo",
  "match.popup.partyInviteBody": "{name} te invitó a un grupo de Aventura.",
  "match.popup.leaveCpuTitle": "¿Salir de la partida contra la CPU?",
  "match.popup.leaveCpuBody": "¿Rendirte y salir de esta partida para aceptar el desafío?",
  "match.popup.accept": "Aceptar",
  "match.popup.decline": "Rechazar",
  "match.popup.leaveSpectateTitle": "¿Salir del modo espectador?",
  "match.popup.forfeitTitle": "¿Rendirte en la partida?",
  "match.popup.leaveSpectateBody": "Dejarás de espectar esta partida.",
  "match.popup.forfeitBody": "Perderás esta partida y saldrás de inmediato.",
  "match.popup.leave": "Salir",
  "match.popup.forfeit": "Rendirse",
  "match.popup.loseTitle": "Esto hará que pierdas",
  "match.popup.loseBodyEquip": "Equipar {name} hará que pierdas.",
  "match.popup.loseBodyActivate": "Activar {name} hará que pierdas.",
  "match.popup.confirm": "Confirmar",
  "match.popup.disconnected": "Desconectado",
  "match.popup.reconnecting": "Te desconectaste, intentando reconectar...",
  "match.popup.hideHint": "Ocultar pista",
  "common.back": "Atrás",
  "common.returnToMenu": "Volver al menú",
  "common.currencyAmount": "{amount} de moneda",
  "draft.title": "Modo Draft",
  "draft.draftedCards": "Cartas elegidas actuales",
  "draft.aspectCount": "Aspecto ({n})",
  "draft.equipmentCount": "Equipo ({n})",
  "draft.abilityCount": "Habilidad ({n})",
  "draft.noneYet": "Ninguna todavía.",
  "draft.roundChoice": "Ronda {round}/{total} · Elección de {kind}",
  "draft.forfeit": "Abandonar Draft",
  "draft.pick": "Elegir",
  "draft.forfeitTitle": "¿Abandonar el Draft?",
  "draft.forfeitBody": "Esto termina todo el Draft en curso.",
  "draft.deckTitle": "Mazo de Draft",
  "draft.deckStatus": "Vidas {lives}/{maxLives} · Partidas {played}/{maxGames} · V {wins} / D {losses} / E {draws}",
  "draft.deckCounts": "Aspecto {aspect}/1 · Equipo {equipment}/{min} · Habilidad {ability}/{min} · Reserva {poolAspect} aspecto / {poolEquipment} equipo / {poolAbility} habilidad",
  "draft.queueCpu": "Cola de partida de Draft contra CPU",
  "draft.queueHuman": "Cola de partida de Draft contra humano",
  "draft.buildHint": "Construye un mazo de 10 equipos / 10 habilidades con tus cartas elegidas.",
  "draft.complete": "Draft completado",
  "draft.collectRewards": "Reclamar recompensas",
  "draft.livesRemaining": "Vidas restantes {lives}",
  "draft.record": "V {wins} / D {losses} / E {draws}",
  "draft.games": "Partidas {games}",
  "draft.reward": "Recompensa",
  "draft.wizardFoils": "Foils de Mago del Draft {n}",
  "draft.deckAspect": "Aspecto del mazo",
  "draft.deckEquipment": "Equipo del mazo",
  "draft.deckAbility": "Habilidad del mazo",
  "draft.poolAspect": "Aspecto de la reserva",
  "draft.poolEquipment": "Equipo de la reserva",
  "draft.poolAbility": "Habilidad de la reserva",
  "draft.costToast": "El Modo Draft cuesta {cost} de moneda (o es gratis una vez al día después de las 4:00 p. m., hora del Centro).",
  "adventure.title": "Modo Aventura",
  "adventure.hp": "{hp}/{maxHp} PS",
  "adventure.gold": "Oro {gold}",
  "adventure.intention": "Intención: {intention}",
  "adventure.actsEvery_one": "Actúa cada {count} turno",
  "adventure.actsEvery_other": "Actúa cada {count} turnos",
  "adventure.nextSuffix": " (siguiente)",
  "adventure.intentNext": "Siguiente: {summary}",
  "adventure.intentIn": "En {turns}: {summary}",
  "adventure.unknown": "Desconocido",
  "adventure.attack": "Ataque",
  "adventure.attackDamage": "{damage} de daño {type}",
  "adventure.attackHeal": "cura {heal} ({target})",
  "adventure.healTargetAllies": "todos los aliados",
  "adventure.healTargetAlly": "un aliado",
  "adventure.healTargetSelf": "a sí mismo",
  "adventure.damageType.physical": "físico",
  "adventure.damageType.magical": "mágico",
  "adventure.damageType.fire": "ígneo",
  "adventure.damageType.cold": "gélido",
  "adventure.damageType.lightning": "eléctrico",
  "adventure.enemy": "Enemigo",
  "adventure.enemyType": "Tipo: {name}",
  "adventure.node": "Nodo",
  "adventure.nodeType.start": "Campamento",
  "adventure.nodeType.combat": "Combate",
  "adventure.nodeType.shop": "Tienda",
  "adventure.nodeType.reward": "Tesoro",
  "adventure.nodeType.story": "Historia",
  "adventure.preview.unknown": "Encuentro desconocido.",
  "adventure.preview.combat": "Un encuentro de combate.",
  "adventure.preview.shop": "Una tienda.",
  "adventure.preview.reward": "Un alijo de tesoro.",
  "adventure.preview.story": "Un evento de historia.",
  "adventure.chooseNodeTitle": "¿Elegir {name}?",
  "adventure.travelNodeTitle": "¿Viajar a {name}?",
  "adventure.chooseUnknownTitle": "¿Elegir nodo desconocido?",
  "adventure.travelUnknownTitle": "¿Viajar a un nodo desconocido?",
  "adventure.pathHidden": "El camino está oculto hasta que llegues.",
  "adventure.partyMustConfirm": "Los miembros del grupo deben confirmar antes de que comience el evento.",
  "adventure.fillDeckBeforeTravel": "Llena tu mazo de Aventura con 10 cartas de equipo y 10 de habilidad antes de viajar.",
  "adventure.choose": "Elegir",
  "adventure.travel": "Viajar",
  "adventure.fillEverySlot": "Llena cada ranura del mazo de Aventura con cartas del inventario antes de viajar. Cada mazo necesita 10 cartas con un máximo de {max} copias de la misma carta.",
  "adventure.waitingPartyConfirm": "Esperando confirmación del grupo ({ready}/{total})",
  "adventure.confirmReady": "Confirmar listo",
  "adventure.effects": "Efectos",
  "adventure.activeEffects": "Efectos activos",
  "adventure.noActiveEffects": "No hay efectos activos.",
  "adventure.inventoryCount": "Inventario {n}/{max}",
  "adventure.defaultDeckName": "Mochila del aprendiz",
  "adventure.deckCounts": "{name} · Aspecto {aspect}/1 · Equipo {equipment}/{min} · Habilidad {ability}/{min}",
  "adventure.deckEditHint": "Toca una ranura para examinarla, vaciarla o reemplazarla con una carta del inventario. Llena cada ranura con un máximo de {max} copias de cada carta para volver a viajar.",
  "adventure.leave": "Dejar",
  "adventure.take": "Tomar",
  "adventure.party": "Grupo",
  "adventure.partyHint": "Invita a jugadores que estén En línea en el menú del Modo Aventura. Hasta 4.",
  "adventure.partyLeader": "Líder: {name}",
  "adventure.leaderSuffix": " (Líder)",
  "adventure.invitedYou": "{name} te invitó",
  "adventure.invite": "Invitar",
  "adventure.noEligible": "No hay jugadores elegibles en línea.",
  "adventure.leaveParty": "Salir del grupo",
  "adventure.waitingParty": "Esperando al grupo…",
  "adventure.combatSummary": "Resumen del combate",
  "adventure.resultGold": "{result} · Oro obtenido {gold}",
  "adventure.enemiesDefeated_one": "{defeated} de {count} enemigo derrotado",
  "adventure.enemiesDefeated_other": "{defeated} de {count} enemigos derrotados",
  "adventure.rewards": "Recompensas",
  "adventure.rewardHint": "Toca una carta para examinarla · Haz clic en Tomar para reservar una recompensa o en Dejar para omitirla",
  "adventure.continueWhenReady": "Continúa cuando estés listo",
  "adventure.resolvingCombat": "Resolviendo combate...",
  "adventure.shop": "Tienda",
  "adventure.shopHint": "Oro {gold} · Toca una carta para examinarla",
  "adventure.buyGold": "Comprar por {price} de oro",
  "adventure.leaveShopWhenReady": "Sal de la tienda cuando estés listo",
  "adventure.leaveShop": "Salir de la tienda",
  "adventure.treasure": "Tesoro",
  "adventure.treasureHint": "Oro {gold} · Toca una carta para examinarla · Haz clic en Tomar para reservar una recompensa o en Dejar para omitirla",
  "adventure.story": "Historia",
  "adventure.youGain": "Obtienes: {effects}",
  "adventure.enteringCombat": "Entrando en combate…",
  "adventure.tabDeck": "Mazo de Aventura",
  "adventure.tabInventory": "Inventario",
  "adventure.tabMap": "Mapa",
  "common.player": "Jugador",
  "common.hoursMinutesShort": "{hours} h {minutes} min",
  "common.minutesShort": "{minutes} min",
  "social.report": "Reportar",
  "social.block": "Bloquear",
  "customize.board": "Tablero",
  "customize.nameColor": "Color del nombre",
  "customize.lockedSuffix": " (Bloqueado)",
  "customize.unlockFor": "Desbloquear {name} por {cost}",
  "customize.confirmPurchase": "Toca de nuevo para comprar",
  "customize.boardName.flat": "Plano",
  "customize.boardName.elegant": "Elegante",
  "customize.boardName.ice": "Hielo",
  "customize.boardName.nature": "Naturaleza",
  "customize.boardName.volcanic": "Volcánico",
  "customize.boardName.castle": "Castillo",
  "customize.boardName.factory": "Fábrica",
  "customize.boardName.swamp": "Pantano",
  "customize.colorName.garnet": "Granate",
  "customize.colorName.scarlet": "Escarlata",
  "customize.colorName.amber": "Ámbar",
  "customize.colorName.gold": "Oro",
  "customize.colorName.verdant": "Verdor",
  "customize.colorName.forest": "Bosque",
  "customize.colorName.abyss": "Abismo",
  "customize.colorName.steel": "Acero",
  "customize.colorName.mist": "Niebla",
  "customize.colorName.white": "Blanco",
  "customize.colorName.cyan": "Cian",
  "customize.colorName.azure": "Azur",
  "customize.colorName.sand": "Arena",
  "customize.colorName.clay": "Arcilla",
  "customize.colorName.umber": "Sombra tostada",
  "customize.colorName.plum": "Ciruela",
  "customize.colorName.rainbow_holo": "Holo arcoíris",
  "customize.colorName.metallic_holo": "Holo metálico",
  "customize.colorName.gilded_holo": "Holo dorado",
  "marketplace.refreshesIn": "Se renueva en {time}",
  "marketplace.cards": "Cartas",
  "marketplace.foils": "Variantes foil",
  "marketplace.sold": "Vendido",
  "marketplace.buy": "Comprar",
  "marketplace.confirmBuy": "Confirmar compra",
  "marketplace.noCards": "No hay cartas bloqueadas disponibles.",
  "marketplace.noFoils": "No hay variantes foil disponibles.",
  "marketplace.notEnough": "No tienes suficiente moneda.",
  "achievements.title": "Logros",
  "achievements.close": "Cerrar logros",
  "achievements.ready": "{n} listos",
  "achievements.completionReward": "Recompensa por completar",
  "achievements.completionRewardCollected": "Recompensa por completar reclamada",
  "achievements.none": "Aún no hay logros.",
  "achievements.collected": "Reclamado",
  "achievements.collect": "Reclamar",
  "achievements.collectCompletionTitle": "Reclama la recompensa por completar",
  "achievements.collectAllFirst": "Primero reclama todos los logros de esta categoría.",
  "achievements.view": "Ver logros",
  "achievements.dailies": "Diarias",
  "achievements.dailiesHint": "Progresa en las diarias en cualquier partida Clásica",
  "achievements.emptySlot": "Ranura vacía",
  "achievements.untilNewDaily": "{time} para la nueva diaria",
  "achievements.newDailyArriving": "Llega una nueva diaria...",
  "achievements.untilExpired": "{time} para que expire",
  "achievements.removeAgainAria": "Pulsa de nuevo para quitar la diaria: {label}",
  "achievements.removeAria": "Quitar diaria: {label}",
  "achievements.removeAgain": "Pulsa de nuevo para quitar",
  "achievements.remove": "Quitar diaria",
  "achievements.rerollAgainAria": "Pulsa de nuevo para cambiar la diaria por {cost} de moneda: {label}",
  "achievements.rerollAria": "Cambiar diaria por {cost} de moneda: {label}",
  "achievements.rerollAgain": "Pulsa de nuevo para cambiar",
  "achievements.reroll": "Cambiar esta diaria (una vez por diaria)",
  "achievements.loadingDailies": "Cargando diarias...",
  "dailies.dealDamage": "Inflige {target} de daño {type}",
  "dailies.applyAilment": "Aplica {target} de {ailment}",
  "dailies.gainResource": "Obtén {target} de {attribute}",
  "dailies.playEquipment": "Juega {target} cartas de Equipo",
  "dailies.playAbility": "Juega {target} cartas de Habilidad",
  "dailies.playAttribute": "Juega {target} cartas de {attribute}",
  "dailies.playKind": "Juega {target} habilidades de clase {kind}",
  "dailies.playTag": "Juega {target} cartas {tag}",
  "dailies.winWithAspect_one": "Gana {count} partida con {name}",
  "dailies.winWithAspect_other": "Gana {count} partidas con {name}",
  "dailies.expendDamage": "Agota equipo {target} veces para infligir daño",
  "dailies.expendEffect": "Agota equipo {target} veces para un efecto que no sea de daño ni de recursos",
  "dailies.activateAbility": "Activa una habilidad activa {target} veces",
  "dailies.invokeCards": "Invoca {target} cartas",
  "dailies.activateCard": "Activa {name} {target} veces",
  "dailies.ailment.burn": "Quemadura",
  "dailies.ailment.poison": "Veneno",
  "dailies.ailment.bleed": "Sangrado",
  "dailies.ailment.shock": "Descarga",
  "dailies.ailment.chill": "Escarcha",
  "dailies.ailment.wither": "Marchitez",
  "match.portrait.closeAria": "Cerrar examen del jugador",
  "match.portrait.deck": "Mazo: {n}",
  "match.portrait.hand": "Mano: {n}",
  "match.portrait.discard": "Descarte: {n}",
  "common.loading": "Cargando…",
  "common.ok": "OK",
  "common.loadingAssets": "Cargando recursos {loaded}/{total}",
  "social.chatMuted": "Estás silenciado y no puedes ver ni enviar mensajes de chat.",
  "social.chatGuest":
    "El chat requiere una cuenta registrada. Crea o migra a una cuenta en Ajustes y luego vuelve aquí.",
  "social.chatLocked":
    "El chat se desbloquea cuando tu cuenta tenga al menos 24 horas de antigüedad o después de completar {games} partidas sin rendirte. Progreso: {completed}/{games} partidas completadas.",
  "social.chatLockedRemaining":
    "El chat se desbloquea cuando tu cuenta tenga al menos 24 horas de antigüedad o después de completar {games} partidas sin rendirte. Progreso: {completed}/{games} partidas completadas (faltan {remaining}).",
  "social.chatAgreeTerms":
    "Acepta los términos del chat del juego para ver y enviar mensajes.",
  "social.players": "Jugadores",
  "social.playersOnline": "{online} / {total} en línea",
  "social.showPlayers": "Mostrar jugadores",
  "social.hidePlayers": "Ocultar jugadores",
  "social.noPlayers": "No hay jugadores.",
  "social.noMessages": "Aún no hay mensajes.",
  "social.messagePlaceholder": "Mensaje",
  "social.reportTitle": "Reportar a {name}",
  "social.reportPrompt":
    "¿Cuál es el problema? Los reportes son privados y los revisa ATN DEV.",
  "social.reportCategory": "Categoría del reporte",
  "social.reportCategoryName.harassment": "Acoso, intimidación o amenazas",
  "social.reportCategoryName.hate": "Discurso de odio o discriminación",
  "social.reportCategoryName.inappropriate": "Contenido sexual o inapropiado",
  "social.reportCategoryName.spam": "Spam o estafas",
  "social.reportCategoryName.cheating": "Trampas o abuso de errores",
  "social.reportCategoryName.username": "Nombre de usuario ofensivo",
  "social.reportCategoryName.other": "Otro",
  "social.reportDetails": "Detalles (opcional)",
  "social.reportDetailsPlaceholder": "Describe brevemente lo que pasó.",
  "social.reportChatIncluded":
    "Los mensajes de chat recientes de este jugador se incluyen con tu reporte.",
  "social.reportBlockHint":
    "También puedes bloquear a {name} para ocultar sus mensajes de chat y gestos.",
  "social.sending": "Enviando…",
  "social.submitReport": "Enviar reporte",
  "social.optIn.title": "Chat del juego opcional",
  "social.optIn.optional":
    "El chat del juego es opcional. Al aceptar, eliges ver y enviar mensajes generados por jugadores.",
  "social.optIn.notMonitored":
    "Los mensajes los crean los jugadores y no representan a ATN DEV. El chat no se supervisa necesariamente antes de aparecer. No des por hecho que el chat es privado o confidencial.",
  "social.optIn.conduct":
    "No uses el chat para amenazas, acoso, odio, estafas, spam, actividades ilegales u otras conductas prohibidas. ATN DEV puede revisar los reportes y advertir, restringir el chat, suspender o bloquear cuentas.",
  "social.optIn.sensitive":
    "No compartas contraseñas, información financiera ni otra información personal sensible en el chat.",
  "social.optIn.detailsBefore": "Los detalles completos están en la ",
  "social.optIn.detailsAfter": ".",
  "social.optIn.agree": "Acepto",
  "social.status.online": "En línea",
  "social.status.offline": "Desconectado",
  "social.status.recentlyOnline": "En línea recientemente",
  "social.status.inCpuGame": "En partida contra CPU",
  "social.status.inGame": "En partida",
  "social.status.spectating": "Espectando",
  "social.status.inDraftQueue": "En cola de Draft",
  "social.status.inQueue": "En cola",
  "social.status.viewingQueue": "Viendo la cola",
  "social.status.deckEditing": "Editando mazo",
  "social.status.viewingCollection": "Viendo la colección",
  "social.status.viewingLibrary": "Viendo la biblioteca",
  "social.status.viewingAchievements": "Viendo logros",
  "social.status.viewingGlossary": "Viendo el glosario",
  "social.status.adjustingSettings": "Ajustando la configuración",
  "social.status.customizingBoard": "Personalizando tablero",
  "social.status.inMarketplace": "En el mercado",
  "social.status.inSocial": "En Social",
  "social.status.viewingRanking": "Viendo la clasificación",
  "social.status.inWorkshop": "En el taller",
  "social.status.viewingCommunity": "Viendo la comunidad",
  "social.status.viewingSupport": "Viendo soporte",
  "social.status.viewingTutorials": "Viendo tutoriales",
  "social.status.viewingSummary": "Viendo el resumen",
  "social.status.drafting": "Haciendo Draft",
  "social.status.buildingDraftDeck": "Construyendo mazo de Draft",
  "social.status.viewingDraftSummary": "Viendo resumen del Draft",
  "social.status.adventureMode": "Modo Aventura",
  "social.status.adventureCombatSummary": "Resumen de combate de Aventura",
  "social.status.inAdmin": "En Administración",
  "social.status.watchingReplay": "Viendo repetición",
  "social.draftMode": "Modo Draft",
  "social.bestDraftRun":
    "Mejor Draft V {wins} / D {losses} / E {draws} · {lives} vidas · {games} partidas",
  "social.draftPool": "Reserva del Draft",
  "social.noDraftRun": "Ningún Draft completado.",
  "social.spectateGame": "Espectar partida",
  "social.blockedNotice":
    "Bloqueaste a este jugador. Sus mensajes de chat y gestos están ocultos, y no puede desafiarte.",
  "social.noDecks": "No hay mazos.",
  "social.deckEquipmentPower": "Equipo · Poder {power}",
  "social.deckAbilitiesPower": "Habilidades · Poder {power}",
  "ranking.cpuWinRatio": "Proporción de victorias contra CPU",
  "ranking.humanWinRatio": "Proporción de victorias contra humanos",
  "ranking.cpuRecord": "CPU V/D/E",
  "ranking.humanRecord": "Humanos V/D/E",
  "ranking.prev": "Ant.",
  "ranking.next": "Sig.",
  "community.discordCopy": "Únete al Discord de Random's Projects.",
  "community.joinDiscord": "Unirse a Discord",
  "support.contactTitle": "Contacto para soporte o reporte de errores",
  "support.contactCopy": "Escríbenos por correo electrónico para pedir ayuda o reportar un problema.",
  "support.privacyPolicy": "Política de privacidad",
  "support.privacyCopy":
    "Qué información recopilamos, quién la recibe, cuánto tiempo la conservamos y cómo eliminar tu cuenta y tus datos.",
  "support.privacyTitle": "Privacidad y seguridad de los datos",
  "support.privacyHighlightCollect":
    "Recopilamos tu nombre de usuario, una contraseña cifrada con hash, el progreso del juego y tu dirección IP con ubicación aproximada. No se requiere correo electrónico y no hay SDK de analítica ni de anuncios.",
  "support.privacyHighlightShare":
    "No vendemos datos personales. Solo nuestros proveedores de alojamiento, geolocalización por IP y correo electrónico los procesan en nuestro nombre.",
  "support.privacyHighlightChat":
    "El chat es opcional, visible para los jugadores con el chat activado y se elimina después de 90 días como máximo.",
  "support.privacyHighlightDelete":
    "Elimina tu cuenta en cualquier momento en Ajustes > Cuenta, en la web o por correo electrónico.",
  "support.privacyRead": "Leer la política de privacidad",
  "support.privacyOpenWeb": "Abrir versión web",
  "support.privacyDeletePage": "Página de eliminación de cuenta",
  "support.privacyPublicNote":
    "Ambas páginas son públicas en aeternainvicta.com/privacy y aeternainvicta.com/delete-account y funcionan sin la app. Solicitudes de privacidad: {email}.",
  "support.monetization": "Información sobre monetización",
  "support.monetizationCopy":
    "Cómo se desarrolla el juego, qué anuncios y Moneda se ofrecen, y nuestro compromiso de no pagar para ganar.",
  "support.designPhilosophy": "Filosofía de diseño",
  "support.designPhilosophyCopy":
    "Una breve carta del diseñador sobre la idea detrás del juego.",
  "support.designPhilosophyButton":
    "Descubre más sobre la idea detrás de Aeterna Invicta",
  "support.credits": "Créditos y agradecimientos",
  "support.creditsCopy":
    "Amigos, probadores y la editorial que ayudaron a hacer esto posible.",
  "support.entryTitle.about": "Acerca de Aeterna Invicta",
  "support.entryTitle.ageRating": "Clasificación por edad y advertencia de contenido",
  "support.entryTitle.community": "Normas de la comunidad y seguridad",
  "support.entryTitle.terms": "Términos de uso",
  "support.entryTitle.accountData": "Cuentas y eliminación de datos",
  "support.entrySummary.about":
    "Qué es el juego, cómo se juega y quién lo hace.",
  "support.entrySummary.ageRating":
    "Destinado a jugadores de 13 años en adelante. Contiene violencia fantástica y representaciones de sangre.",
  "support.entrySummary.community":
    "Cómo mantenerte seguro, qué no está permitido y cómo reportar un problema.",
  "support.entrySummary.terms":
    "Las reglas para usar el juego, tu cuenta y los objetos del juego.",
  "support.entrySummary.accountData":
    "Juego como invitado, cuentas registradas y cómo eliminar tu cuenta y tus datos.",
  "support.contact.type": "Tipo",
  "support.contact.bug": "Reporte de errores",
  "support.contact.email": "Correo electrónico (para recibir respuesta)",
  "support.contact.bugPrompt":
    "Describe qué estabas haciendo y qué estaba pasando cuando ocurrió el error.",
  "support.contact.helpPrompt": "¿Cómo podemos ayudarte?",
  "support.contact.send": "Enviar",
  "support.contact.sentTitle": "Mensaje enviado",
  "support.contact.enterEmail": "Introduce una dirección de correo electrónico válida.",
  "support.contact.enterMessage": "Introduce un mensaje.",
  "support.contact.sendFailed": "No se pudo enviar. Inténtalo de nuevo.",
  "support.contact.confirmation":
    "Para completar el contacto, envía el correo preparado a {email} desde tu proveedor de correo electrónico.",
  "lore.readMore": "Leer más",
  "rulebook.title": "Reglamento de Aeterna Invicta",
  "rulebook.contents": "Contenido",
  "rulebook.tableOfContents": "Índice",
  "support.privacyLoadFailed": "No se pudo cargar la política de privacidad.",
  "social.reportSubmitted":
    "Reporte enviado. Gracias por ayudar a mantener Aeterna Invicta seguro.",
  "social.reportFailed": "No se pudo enviar el reporte.",
  "social.playerFallback": "jugador",
  "social.partyInviteSent": "Invitación de grupo enviada a {name}.",
  "social.challengeSent": "Desafío enviado a {name}.",
  "social.challengeDeclined": "Desafío rechazado.",
  "social.challengeDeclinedBy": "{name} rechazó tu desafío.",
  "account.createdSignInRequired": "Cuenta creada, pero debes iniciar sesión.",
  "account.createdPlayingAs": "Cuenta creada. Jugando como {name}.",
  "library.collection": "Colección",
  "library.rulebook": "Reglamento",
  "library.glossary": "Glosario",
  "library.lore": "Trasfondo",
  "library.intro":
    "Explora tu colección y mazos de ejemplo, consulta palabras clave y mecánicas, o lee el trasfondo del reino.",
  "library.decksIntro":
    "Mazos de ejemplo que puedes ver como inspiración o exportar para usarlos si tienes las cartas desbloqueadas.",
  "library.missingCards": "Cartas que faltan en tu colección",
  "library.noDecks": "No hay mazos de la biblioteca disponibles.",
  "library.resetDecks": "Restablecer mazos",
  "library.resetDecksTitle": "¿Restablecer mazos?",
  "library.resetDecksBody":
    "Esto reemplaza todos tus mazos guardados por los mazos de la Biblioteca de los que tienes todas las cartas. Se perderán los mazos personalizados y las ediciones.",
  "library.export": "Exportar",
  "library.deckAbilityPower": "Habilidad · Poder {power}",
  "glossary.backToSearch": "Volver a la búsqueda",
  "glossary.relatedCards": "Cartas relacionadas ({n})",
  "glossary.noRelatedCards": "No se encontraron cartas relacionadas.",
  "glossary.search": "Buscar",
  "glossary.searchPlaceholder": "Palabras clave, términos, mecánicas",
  "glossary.noMatches": "No hay términos coincidentes.",
  "patchNotes.title": "Notas del parche",
  "workshop.showControls": "Mostrar controles",
  "workshop.hideControls": "Ocultar controles",
  "workshop.addCard": "Añadir carta",
  "workshop.yourTurn": "Tu turno",
  "workshop.opponentTurn": "Turno del oponente",
  "workshop.reset": "Reiniciar",
  "workshop.hp": "PS {hp}/{maxHp}",
  "workshop.switchAspectFor": "Cambiar Aspecto de {name}",
  "workshop.addCardTo": "Añadir carta a {name}",
  "workshop.chooseAspect": "Elige un Aspecto para este asiento.",
  "workshop.maxCopiesPerSide": "Máximo {max} copias de la misma carta por lado.",
  "gamepad.connected": "Mando conectado",
  "gamepad.statusTitle": "{pad} · Select alterna barra de navegación/vista",
  "gamepad.ariaNav": "Mando conectado, barra de navegación seleccionada",
  "gamepad.ariaView": "Mando conectado, vista seleccionada",
  "gamepad.padNav": "Mando · Nav.",
  "gamepad.padView": "Mando · Vista",
  "gamepad.connectedToast": "Mando conectado: {label}",
  "card.statusEffect": "Efecto de estado",
  "card.empoweredPhysicalArmor": "Potenciado: Armadura física +{amount} (Rasgo, mientras esté equipado)",
  "card.empoweredMagicArmor": "Potenciado: Armadura mágica +{amount} (Rasgo, mientras esté equipado)",
  "card.levels": "Niveles",
  "card.level": "Nivel",
  "card.cost": "Costo",
  "card.tapToReturn": "Toca para devolver la carta",
  "card.powerN": "Poder {power}",
  "card.locked": "Bloqueada",
  "match.board.needResource": "Necesitas {need} de {attribute} (tienes {have})",
  "match.board.needHealth": "Necesitas {need} de salud (tienes {have})",
};

export default es;
